import { debounce } from '@/utility/functions';

let $orders;

function decodeQueryString(qs) {
  if(!qs || qs === '') return {};

  return JSON.parse(
    '{"' + qs.replace(/&/g, '","').replace(/=/g,'":"') + '"}',
    (key, value) => {
      return key === '' ? value : decodeURIComponent(value);
    }
  );
}

function searchOrders() {
  window.axios.get('/account/orders/fetch', {
    params: decodeQueryString(window.location.search.substring(1)),
  })
  .then(response => {
    $orders.innerHTML = response.data;
  })
  .catch(error => {})
  .then(() => {
    $orders.classList.remove('opacity-25');

    if(window.scrollY <= $orders.offsetTop) {
      return;
    }

    if(!window.scroll) {
      $orders.scrollIntoView(true);

      return;
    }

    window.scroll({
      top: $orders.offsetTop - 140,
      behavior: 'smooth',
    });
  });
}

function searchByKeyword(event) {
  if(window.history.pushState && event.target.nodeName === 'INPUT') {
    const qs = decodeQueryString(window.location.search.substring(1));

    qs.page = 1;
    qs.keyword = event.target.value;

    window.history.pushState(qs, '', '?' + new URLSearchParams(qs).toString());

    $orders.classList.add('opacity-25');

    searchOrders();
  }
}

window.addEventListener('vueloaded', () => {
  $orders = document.getElementById('customer-orders');

  if($orders) {
    searchOrders();

    $orders.addEventListener('input', debounce(searchByKeyword, 500));

    $orders.addEventListener('click', (event) => {
      if(window.history.pushState) {
        if(event.target.nodeName === 'A' && event.target.closest('.pagination')) {
          event.preventDefault();

          const index = event.target.href.indexOf('?');
          const qs = index >= 0 ? event.target.href.substring(index + 1) : '';

          window.history.pushState(decodeQueryString(qs), '', '?' + qs);

          $orders.classList.add('opacity-25');

          searchOrders();
        }
      }
    });
  }
});
